import React, { useState } from "react";
import PropTypes from "prop-types";

// import LocationPreview from "./LocationPreview/LocationPreview";
import LocationList from "./LocationList";
import ModalBuilder from "./Modal";
import ModalNoRegions from "./ModalNoRegions";

const LocationBuilder = props => {
  const {
    toggle,
    isOpen,
    selectedRegions,
    country,
    onSelect,
    regionsList,
    isLoading
  } = props;
  const [show, setShow] = useState(false);

  const handleSelect = sel => {
    if (sel?.length === 0) {
      setShow(true);
    }
    onSelect(sel);
  };

  const getLocationList = () => {
    if (
      selectedRegions.length === 0 ||
      regionsList.length === selectedRegions.length
    ) {
      return [country];
    }
    return selectedRegions;
  };

  return (
    <>
      {/* {!selectedRegions.length ? (
        <LocationPreview onAddLocation={toggle} />
      ) : (
        <LocationList
          list={selectedRegions.length ? selectedRegions : [country]}
        />
      )} */}
      <LocationList
        isLoading={isLoading}
        list={getLocationList()}
        country={
          selectedRegions.length === 0 ||
          regionsList.length === selectedRegions.length
        }
      />
      {isOpen && (
        <ModalBuilder
          selectedRegions={selectedRegions}
          regionsList={regionsList}
          isOpen={isOpen}
          onSelect={handleSelect}
          toggle={toggle}
          country={country}
        />
      )}
      <ModalNoRegions isOpen={show} toggle={() => setShow(false)} />
    </>
  );
};

LocationBuilder.propTypes = {
  selectedRegions: PropTypes.arrayOf(PropTypes.shape({})),
  regionsList: PropTypes.arrayOf(PropTypes.shape({})),
  country: PropTypes.shape({}),
  onSelect: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool
};

LocationBuilder.defaultProps = {
  selectedRegions: [],
  regionsList: [],
  isOpen: false,
  country: {},
  isLoading: false
};

export default LocationBuilder;
